import 'react-table/react-table.css'
import '../../../_components/table/table.styles.css'

import Spinner from '@helvetia/components/Spinner'
import dayjs from 'dayjs'
import numeral from 'numeral'
import * as React from 'react'
import { WithNamespaces, withNamespaces } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ReactTable from 'react-table'

import { LifecycleView } from '../../../_components/ConnectComponent'
import { offerDocumentViewMapper } from '../OfferView.mapper'
import { ExpiredTablePresenter } from './ExpiredTable.presenter'

export interface View extends LifecycleView {
  showLoading: () => void
  hideLoading: () => void
}

interface Props {
  presenter: ExpiredTablePresenter
}

interface State {
  isLoading: boolean
  page: number
  pages: number
  pageSize: number
  expiredOfferList: any[]
}

export class ExpiredTableRaw
  extends React.Component<Props & RouteComponentProps & WithNamespaces, State>
  implements View {
  private presenter: ExpiredTablePresenter

  constructor(props) {
    super(props)

    this.presenter = props.presenter
    this.presenter.initialize(this)

    this.state = {
      isLoading: false,
      page: 0,
      pages: 1,
      pageSize: 20,
      expiredOfferList: [],
    }
  }

  setInitialValues = (expiredOfferList, pagination) => {
    this.setState({
      expiredOfferList: expiredOfferList.map(offerDocumentViewMapper),
      page: pagination.currentPage,
      pages: pagination.totalPages,
      pageSize: pagination.itemsPerPage,
    })
  }

  getExpiredOffers = () => {
    this.presenter
      .getExpiredOffers(this.state.page, this.state.pageSize)
      .then(response => {
        this.setState(
          {
            expiredOfferList: response.expired.map(offerDocumentViewMapper),
            page: response.pagination.currentPage,
            pages: response.pagination.totalPages,
            pageSize: response.pagination.itemsPerPage,
          },
          this.hideLoading,
        )
      })
  }

  onPageChange = page => {
    this.setState({ isLoading: true, page }, this.getExpiredOffers)
  }

  onPageSizeChange = (pageSize: number) => {
    this.setState({ isLoading: true, pageSize }, this.getExpiredOffers)
  }

  showLoading = () => this.setState({ isLoading: true })

  hideLoading = () => this.setState({ isLoading: false })

  render() {
    const { isLoading, expiredOfferList } = this.state
    const { t } = this.props

    if (isLoading) return <Spinner size="xl" />

    return (
      <ReactTable
        manual
        resizable={false}
        filterable={true}
        showPagination={true}
        loading={false}
        data={expiredOfferList}
        columns={this.columns()}
        onPageChange={page => this.onPageChange(page)}
        onPageSizeChange={pageSize => this.onPageSizeChange(pageSize)}
        page={this.state.page}
        pageSize={this.state.pageSize}
        pages={this.state.pages}
        previousText={t('pagination.previous')}
        nextText={t('pagination.next')}
        pageText={t('pagination.pages')}
        ofText={t('pagination.ofTotal')}
        rowsText={t('pagination.rowsSelectorText')}
      />
    )
  }

  columns() {
    const { t } = this.props
    const { expiredOfferList } = this.state

    if (expiredOfferList && expiredOfferList.length < 1) {
      return []
    }

    return [
      {
        Header: () => <span>ID</span>,
        accessor: 'offerNumber',
        filterable: false,
        width: 100,
        Cell: props => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            {props.value}
          </div>
        ),
      },
      {
        Header: () => t('table.validity'),
        accessor: 'creationOfferDate',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 250,
        Cell: row => (
          <div>
            {`${dayjs(row.original.creationOfferDate).format(
              'DD.MM.YYYY',
            )} (${t('table.creationDate')})`}
            <br />
            {`${dayjs(row.original.creationOfferDate)
              .add(3, 'month')
              .format('DD.MM.YYYY')} (${t('table.cancelDate')})`}
          </div>
        ),
      },
      {
        Header: () => t('table.price'),
        accessor: 'price',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 150,
        Cell: props => numeral(props.value).format('0,0.00'),
      },
      {
        Header: () => t('table.customer'),
        accessor: 'company',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 300,
        Cell: row => (
          <div>
            {row.original.company}
            <br />
            {row.original.firstName + ' ' + row.original.lastName}
          </div>
        ),
      },

      {
        Header: () => t('table.contact'),
        accessor: 'email',
        // filterable: true,
        filterable: false,
        sorteable: true,
        width: 300,
        Cell: row => (
          <div>
            {row.original.email}
            <br />
            {row.original.phone && row.original.phone.trim().length > 3
              ? row.original.phone
              : ''}
          </div>
        ),
      },
      /* Filter: ({ onChange }) => (
        <select
          onChange={event => {
            onChange(event.target.value)
            this.props.onRiskTypeSelectorChange(Number(event.target.value))
            this.setState({ isInitialState: false })
          }}
          style={{ width: '100%' }}
          value={
            this.props.riskFilters && this.props.riskFilters.riskTypeId
              ? this.props.riskFilters.riskTypeId
              : 'all'
          }
        >
          {this.printOptionList(this.state.riskTypeList, t)}
        </select>
      ), */
    ]
  }
}

export const ExpiredTableView = withNamespaces()(withRouter(ExpiredTableRaw))
